export const loadGTM = () => {
  const gtmEnabled = import.meta.env.VITE_GTM_ENABLED === 'true';
  const environmentName = import.meta.env.VITE_ENV;
  const gtmId = import.meta.env.VITE_GTM_ID;

  if (!gtmEnabled || !gtmId || !environmentName) {
    return;
  }

  const script = document.createElement('script');
  const noscript = document.createElement('noscript');

  if (environmentName === 'production') {
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  }
  else {
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}&gtm_auth=TiRd6gA47HlGYhtSs-jrig&gtm_preview=env-4&gtm_cookies_win=x`;
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}&gtm_auth=TiRd6gA47HlGYhtSs-jrig&gtm_preview=env-4&gtm_cookies_win=x"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  }
  document.head.append(script);
  document.body?.append(noscript);
  console.log(`GTM loaded with env: ${environmentName}, ID: ${gtmId}`);
};
